import { Anchor, AnchorProps } from "@mantine/core";
import { Link } from "react-router-dom";

interface CustomAnchorProps extends AnchorProps {
  children: React.ReactNode | React.ReactNode[] | string,
  to?: string;
  component?: 'a' | 'button';
  disabled?: boolean;
  onClick?: () => void;
}

const CustomAnchor = ({ children, onClick, component = 'a', disabled, to = "#", ...props }: CustomAnchorProps) => (
  <Anchor
    component={Link}
    to={to}
    {...props}
    onClick={onClick}
  >
    {children}
  </Anchor>
)

export default CustomAnchor;